import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query omieInstallments($integrationId: Int, $page: Int) {
    omieInstallments(integrationId: $integrationId, page: $page, limit: 30) {
      cDescricao
      nCodigo
      nParcelas
    }
  }
`

export const useInstallmentsSelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'omieInstallments']))
      .then(data => {
        const result = data.map((item, index) => {
          return { id: index, name: item?.cDescricao, nCodigo: item?.nCodigo, nParcelas: item?.nParcelas }
        })

        return result
      })
  }
}

const InstallmentsSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useInstallmentsSelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default InstallmentsSelect
